export enum AuthErrorCode {
    AuthRejected = 'auth_rejected',
    EmailInvalid = 'email_invalid',
    EmailOtpInvalid = 'email_otp_invalid',
    OtpDeliveryFailed = 'otp_delivery_failed',
    OtpInvalid = 'otp_invalid',
    OtpNotFound = 'otp_not_found',
    PhoneInUse = 'phone_in_use',
    RecoveryCodeInvalid = 'recovery_code_invalid',
    RecoveryInvalidOrExpired = 'recovery_invalid_or_expired',
    RegistrationInvalidOrExpired = 'registration_invalid_or_expired',
    RegistrationUnavailable = 'registration_unavailable',
    RequestFailed = 'request_failed',
    UserNotFound = 'user_not_found',
    UsernameInvalid = 'username_invalid',
}
